import { axios } from "../api/axios";
import { axiosMA } from "../api/axiosMA";

export const getItemShopComService = async (data: any) => {
    return await axios.post('shopping/products',data)
}

export const getItemDetailService = async (ids: String, locale: String) => {
    return await axiosMA.get(`/AffiliatePublisherNetwork/v2/products/ids/${ids}?locale=${locale}&publisherId=AP1701813&summary=true&api_key=c305557df29a4bb2b487ee6fefc35425`)
}

export const postCheckout = async (data: any) => {
    return await axiosMA.post('cart-universal/v2/carts?api_key=c305557df29a4bb2b487ee6fefc35425',data)
}